jQuery(function($){
	const pluginSlug = 'choralshop-partners';

	$('.commission-report input[name="payment_type"]').on('change', function(){
		if(this.value == 'venmo') {
			$(this).closest('form').attr('target', '_blank');
		} else {
			$(this).closest('form').attr('target', '_self');
		}
	});

	$('.commission-report').on('submit', 'form[target="_blank"]', function(){
		const currentUrl = window.location.href;
		const newUrl = currentUrl + '#update-payment-status';
		console.log('test');
		setTimeout(function(){
			window.location.href = newUrl;
			window.location.reload();
		}, 1000);
	});

	setTimeout(function(){
		const currentUrl = window.location.href;
		if(currentUrl.includes('#update-payment-status') && $('#commission-report').length) {
			$('#commission-report').addClass('show-payment-options');
			console.log('yes!');
		}
	}, 500);
});